module.exports = __webpack_public_path__ + "img/warning-big.6a9273d7.svg";